import { Layout as CompLayout } from "@shared/ui";
import styles from "./Layout.module.scss";

import { Outlet, useLocation } from "react-router-dom";

import { ProtectedLayoutWrapper } from "@entities/auth";
import { Sidebar } from "@features/sidebar";
import { Header as AndtdHeader, Content } from "antd/es/layout/layout";
import { useEffect, useState } from "react";
import { Header } from "./Header/Header";

const isBriefRoute = (pathname: string) => pathname.startsWith("/brief/v2/");

export function Layout() {
  const location = useLocation();
  const isOnBriefRoute = isBriefRoute(location.pathname);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState<boolean>(
    () => isOnBriefRoute
  );

  useEffect(() => {
    setIsSidebarCollapsed(isOnBriefRoute);
  }, [isOnBriefRoute]);

  return (
    <ProtectedLayoutWrapper>
      <CompLayout className={styles.layout}>
        <Sidebar
          collapsed={isSidebarCollapsed}
          toggleSidebar={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
        />
        <CompLayout className={styles.content}>
          <AndtdHeader
            style={{
              background: "var(--bg-primary)",
              borderBottom: "1px solid var(--border-primary)",
              padding: "0 20px",
              height: "46px",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              flexShrink: 0,
            }}
          >
            <Header />
          </AndtdHeader>
          <Content className={styles.innerContent}>
            <div className={styles.contentWrapper}>
              <Outlet />
            </div>
          </Content>
        </CompLayout>
      </CompLayout>
    </ProtectedLayoutWrapper>
  );
}
